import React from 'react';

type NoPlansCopy = {
  title: string;
  description: string;
  helper?: string;
};

const DEFAULT_COPY: NoPlansCopy = {
  title: "Oops — you didn't pick a plan.",
  description: "It's like getting to checkout with an empty cart.",
  helper: 'Click the Previous button and choose a plan or two, or three.',
};

interface NoPlansSelectedProps {
  copy?: NoPlansCopy;
}

export const NoPlansSelected: React.FC<NoPlansSelectedProps> = ({ copy }) => {
  const content = copy || DEFAULT_COPY;

  return (
    <div className="w-full h-full min-h-[400px] flex flex-col items-center justify-center gap-8 px-16 py-16">
      <div className="text-center">
        {content.title && (
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            {content.title}
          </h2>
        )}
        {content.description && (
          <p className="text-lg text-gray-600 leading-relaxed">
            {content.description}
          </p>
        )}
        {content.helper && (
          <p className="text-lg text-gray-600 leading-relaxed mt-2">
            {content.helper}
          </p>
        )}
      </div>
    </div>
  );
};
